import { all, fork, put, select, takeEvery } from "redux-saga/effects";
import { SignalRTypes, SportTypesActionTypes } from "../actions";
import { Enums } from "../../helpers";

export function* requests() {
  yield takeEvery(SignalRTypes.OnUpcomingDrawsResponse, function*({
    response,
  }) {
    try {
      window.console.response("RES UpcomingDraws=>", response);
      const { sportTypes } = yield select();
      let data;
      if (sportTypes.addNewList && sportTypes.upcomingDrawsEvents) {
        data = {
          ...sportTypes.upcomingDrawsEvents,
          ...response.data.sportEvents,
        };
      } else {
        data = { ...response.data.sportEvents };
      }
      switch (response.status) {
        case 1:
          yield put({
            type: SignalRTypes.OnUpcomingDrawsSuccess,
            upcomingDrawsEvents: { ...data },
          });

          break;

        case 3:
          yield put({
            type: SignalRTypes.OnUpcomingDrawsError,
            error: response.message,
          });
          break;
      }
    } catch (e) {
      window.log("ERROR", e);
    }
  });
  yield takeEvery(
    SignalRTypes.Get_Draws_Categories_And_Tournaments_Response,
    function*({ response }) {
      try {
        window.console.response(
          "RES onDrawsCategoriesAndTournaments=>",
          response
        );

        switch (response.status) {
          case 1:
            yield put({
              type: SignalRTypes.Get_Draws_Categories_And_Tournaments_Success,
              drawsCategories: response.data && response.data,
            });

            break;

          case 3:
            yield put({
              type: SignalRTypes.Get_Draws_Categories_And_Tournaments_Error,
              error: response.message,
            });
            break;
        }
      } catch (e) {
        window.log("ERROR", e);
      }
    }
  );
  yield takeEvery(
    SignalRTypes.Get_Lucky_Numbers_Event_Result_Response,
    function*({ response }) {
      try {
        window.console.response("RES OnEventResult=>", response);

        const { sportTypes } = yield select();
        let data;
        if (sportTypes.addToEvents && sportTypes.luckyNumbersEventResult) {
          console.log("response.data", response.data);
          let prevEvents = sportTypes.luckyNumbersEventResult;
          let newEvents = prevEvents.concat(response.data);
          data = newEvents;
          console.log("data1111", data);
        } else {
          data = response.data;
        }

        switch (response.status) {
          case 1:
            yield put({
              type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Success,
              luckyNumbersEventResult: data,
            });

            break;

          case 3:
            yield put({
              type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Error,
              error: response.message,
            });
            break;
        }
      } catch (e) {
        window.log("ERROR", e);
      }
    }
  );
  yield takeEvery(
    SignalRTypes.Get_Suggested_Balls_Response,
    function*({ response }) {
      try {
        window.console.response("RES OnSuggestedBalls=>", response);
        switch (response.status) {
          case 1:
            yield put({
              type: SignalRTypes.Get_Suggested_Balls_Success,
              suggestedBalls: response.data,
            });

            break;

          case 3:
            yield put({
              type: SignalRTypes.Get_Suggested_Balls_Error,
              error: response.message,
            });
            break;
        }
      } catch (e) {
        window.log("ERROR", e);
      }
    }
  );
}
export default function* LuckyNumberSaga() {
  yield all([fork(requests)]);
}
